import { fg } from '@confluence/feature-gating';

import { useExperimentEnrollment } from './useExperimentEnrollment';
import { useFireExposureEvents } from './useFireExposureEvents';

export const useConfluenceEADropdownExperimentAA = ({
	extraAnalytics = {},
	skip = false,
}: {
	extraAnalytics?: object;
	skip?: boolean;
}) => {
	const aaExperimentIsEnabled = Boolean(fg('confluence_ea_dropdown_aa_fg'));

	return useConfluenceEADropdownExperiment({
		isExperimentEnabled: aaExperimentIsEnabled,
		extraAnalytics,
		skip,
		experimentName: 'confluence_ea_dropdown_aa',
	});
};

export const useConfluenceEADropdownExperimentAB = ({
	extraAnalytics = {},
	skip = false,
}: {
	extraAnalytics?: object;
	skip?: boolean;
}) => {
	const abExperimentIsEnabled = Boolean(fg('confluence_ea_dropdown_ab_fg'));

	return useConfluenceEADropdownExperiment({
		isExperimentEnabled: abExperimentIsEnabled,
		extraAnalytics,
		skip,
		experimentName: 'confluence_ea_dropdown_ab',
	});
};

export const useConfluenceEADropdownExperiment = ({
	isExperimentEnabled,
	experimentName,
	skip = false,
	extraAnalytics = {},
}: {
	isExperimentEnabled: boolean;
	experimentName: string;
	extraAnalytics?: object;
	skip?: boolean;
}) => {
	const { cohort, isTreatment, isEnrolled } = useExperimentEnrollment(experimentName);

	const { fireExposureEvents } = useFireExposureEvents({
		skip: !(isEnrolled && isExperimentEnabled) || skip,
		experimentName,
		extraAnalytics: extraAnalytics || {},
	});

	fireExposureEvents();

	return {
		cohort,
		renderTreatment: isExperimentEnabled && isTreatment,
	};
};
